/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HelpdeskSyncDocumentsPathParameters } from 'api/actions/helpdesk-sync-documents/helpdesk-sync-documents-path-parameters';
import { HelpdeskSyncDocumentsResponse } from 'api/actions/helpdesk-sync-documents/helpdesk-sync-documents-response';

type HelpdeskSyncDocumentsQueryParameters = Record<string, any>;

/**
 * The path of the HelpdeskSyncDocuments action.
 */
export const helpdeskSyncDocumentsActionPath = new SweetPath<keyof HelpdeskSyncDocumentsPathParameters>(
  '/help-desk/documents/sync',
  { path: '{param}' }
);

/**
 * Creates a contextualized HelpdeskSyncDocuments actions.
 */
export default function createHelpdeskSyncDocumentsAction(axios: AxiosInstance) {
  return function helpdeskSyncDocumentsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: HelpdeskSyncDocumentsQueryParameters } = {}) {
    const path = helpdeskSyncDocumentsActionPath.original;

    return axios.get<HelpdeskSyncDocumentsResponse, HelpdeskSyncDocumentsResponse>(path, { params: query, headers });
  };
}
